/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { RootState } from '../../../../ts/state';

/**
 * Selector to see if the user's access to the instance has been denied
 * @param {Object} state The current state
 * @return {boolean} true if the user's access to the instance has been denied, otherwise false
 */
export const selectAccessDenied = (state: RootState): boolean =>
  state.messages.accessDenied;
